// React for Website

import React, { useState } from "react";
//outsource
import { Form, Input } from "antd";

//components

const VoucherFullName = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="firstName"
      label="Receiver First Name"
      rules={[
        {
          required: true,
          message: "Please input First name",
        },
        {
          max: 32,
          message: "Max length is 32 character",
        },
        {
          pattern: /^[A-Za-z ]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input maxLength={32} showCount placeholder="Please input First name" />
    </Form.Item>
  );
};

export default VoucherFullName;
